import { Feature as CoreFeature } from '@app/core/interfaces/c5/feature';
import { FeatureName } from '@app/core/interfaces/c5/feature-name';
import { DomainLevel } from '@app/core/models/domain-level';
import { deepmerge } from '@app/utils/deepmerge';
import { FeatureStatus } from '@business/feature/interfaces/feature-status';

export interface Feature extends CoreFeature {}

export class FeatureModel<T> implements Feature {
  public featName: FeatureName;
  public groupId?: number; // Option[Int]
  public id: number;
  public level: DomainLevel;
  public numberRangeId?: number; // Option[Int]
  public overridingUserFeature: boolean;
  public status: FeatureStatus;
  public timeTableActive: boolean;
  public userId: number;

  constructor(feature: T) {
    Object.assign(this, deepmerge({}, feature));
  }

  get active(): boolean {
    return this.status === FeatureStatus.ACTIVE;
  }

  set active(value: boolean) {
    this.status = value ? FeatureStatus.ACTIVE : FeatureStatus.INACTIVE;
  }
}
